import styled from 'styled-components';

import { styledReset, styledTypography } from '@pkg/primitives';

import { tokens } from './tokens';

export const Input = styled.input.attrs({ type: 'number' })`
    ${styledReset.inputNumber};
    ${styledTypography.allianceBase};
    font-size: ${tokens.input.fontSize}px;
    text-align: center;
`;
